module.exports = __webpack_public_path__ + "img/logo-white.a3494457.webp";